import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";

// fields: [key, label, type ("text"|"number"|"date"|"datetime"|"textarea"|"select"), options?]
export function RecordEditor({ edit, onClose, onSaved }) {
  const [v, setV] = useState({});
  useEffect(() => {
    if (!edit) return;
    setV(Object.fromEntries(edit.fields.map(([k, , t]) => {
      const raw = edit.record[k] ?? "";
      return [k, t === "date" ? String(raw).slice(0, 10) : t === "datetime" && raw ? new Date(raw).toISOString().slice(0, 16) : Array.isArray(raw) ? raw.join(", ") : raw];
    })));
  }, [edit]);
  if (!edit) return null;
  const save = async () => {
    try {
      const body = Object.fromEntries(edit.fields.map(([k, , t, , list]) => [k,
        t === "number" ? Number(v[k]) || 0 : t === "datetime" && v[k] ? new Date(v[k]).toISOString() : list ? String(v[k] || "").split(",").map((x) => x.trim()).filter(Boolean) : v[k]]));
      await api.patch(edit.url, body);
      toast.success(`${edit.title} updated`); onSaved();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const input = ([k, , t, opts]) => {
    const common = { value: v[k] ?? "", "data-testid": `rec-edit-${k}` };
    if (t === "textarea") return <Textarea rows={3} {...common} onChange={(e) => setV({ ...v, [k]: e.target.value })} />;
    if (t === "select") return (
      <select {...common} onChange={(e) => setV({ ...v, [k]: e.target.value })} className="w-full h-10 border border-slate-200 rounded-md px-2 text-sm bg-white">
        <option value="">—</option>{(opts || []).map((o) => (Array.isArray(o) ? <option key={o[0]} value={o[0]}>{o[1]}</option> : <option key={o} value={o}>{o}</option>))}
      </select>);
    return <Input type={t === "datetime" ? "datetime-local" : t || "text"} {...common} onChange={(e) => setV({ ...v, [k]: e.target.value })} />;
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-white max-w-xl max-h-[88vh] overflow-y-auto">
        <DialogHeader><DialogTitle>Edit {edit.title}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          {edit.fields.map((f) => <div key={f[0]} className={f[2] === "textarea" ? "col-span-2" : ""}><Label className="text-xs">{f[1]}</Label>{input(f)}</div>)}
        </div>
        <DialogFooter><Button variant="outline" onClick={onClose}>Cancel</Button><Button onClick={save} className="bg-[#312E81]" data-testid="rec-edit-save">Save</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
